import React from 'react';
import '../css/AIProjects.css';

const aiProjects = [
  {
    name: 'Voice Clone AI – Biometric Verification App',
    description: 'Face verification system with selfie capture and voice clone tech using FastAPI + React.',
    imageUrl: 'https://i.ibb.co/DHWJVr1Z/Screenshot-2025-04-30-at-9-49-11-AM.png',
    link: 'https://www.oz-ai.xyz/'
  },
  {
    name: 'RamizKaraEski GPT — Your Personal AI Side-Kick',
    description: 'A “full-stack” assistant woven into your own toolchain. It marries a large-language-model brain with direct integrations to your Gmail, Google Calendar, macOS utilities, and any custom endpoints you bolt on.',
    imageUrl: 'https://i.ibb.co/4whVf105/3.png',
    link: 'https://www.ramizkaraeskigpt.xyz/'
  },

  {
    name: 'Code AI Tester',
    description: 'Created an AI-powered code analysis tool with ZIP-upload, lint/security scans, and auto-generated docs/tests/refactors via Ollama LLM. Reduced manual QA and documentation effort by 40% across 3 dev teams.',
    imageUrl: 'https://i.ibb.co/qLt630Xs/Screenshot-2025-05-11-at-8-12-35-AM.png',
    link: 'https://www.ozaicodetester.services/'
  },
];

const AIProjects = () => {
  return (
    <section id="ai-projects" className="ai-projects-section">
      <h1 className="ai-projects-title">🤖 AI Projects</h1>
      <div className="ai-projects-grid">
        {aiProjects.map((project, index) => (
          <div className="ai-card" key={index}>
            <img src={project.imageUrl} alt={project.name} className="ai-card-image" />
            <h2 className="ai-card-title">{project.name}</h2>
            <p className="ai-card-desc">{project.description}</p>
            <a
              href={project.link}
              className="btn-accent"
              target="_blank"
              rel="noreferrer"
            >
              View Project →
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AIProjects;
